import { getQueryParamOptional } from "@src/utils/routing";
import { useRouter } from "next/router";
import type { Query } from "nextjs-routes";
import { useEffect } from "react";
import type { Store } from "../store";

const parsePeriod = (query: Query) => {
  const month = Number(getQueryParamOptional("month", query));
  if (Number.isNaN(month)) return;
  const year = Number(getQueryParamOptional("year", query));
  if (Number.isNaN(year)) return;
  return { month, year };
};

export const useSetStoreFromURL = (store: Store): void => {
  const { query } = useRouter();
  useEffect(() => {
    store.pagination.fromURLSearchParam(query);
    const period = parsePeriod(query);
    if (period) {
      store.setPeriod(period);
    }
  }, []);
};
